import styled from 'styled-components';

const RuleValueInput = styled.div`
  display: flex;
  align-items: center;

  > * {
    flex-grow: 1;
  }

  input {
    min-width: 10rem;
  }
`;

export { RuleValueInput };
